import React from 'react'
import PropTypes from 'prop-types'
import DataSource from '../DataSource'
import SqField from '../sq/SqField'
import {ACTIVE_LEFT, ACTIVE_RIGHT, SERVICE_NBN, VOIP_PAYG, VOIP_UNLIMITED, OFFER_ENDING_TEXT, UNCONNECTED_SERVICES_CAMPAIGNS, UNCONNECTED_STANDARD, UNCONNECTED_BOOST} from '../constants'
import BroadbandContainer from '../components/BroadbandContainer'
import NbnFeatures from './NbnFeatures'
import globals from '../globals'
import PlanHOC from '../layout/PlanHOC'
import HighlightText from '../components/HighlightText'
import StepTag from '../components/StepTag'
import ComparePlansBroadband from '../components/ComparePlansBroadband'
import BroadbandOrderSummary from '../components/BroadbandOrderSummary'
import BannerNbn from '../banners/BannerNbn'
import ExpandableListModule from '../modules/ExpandableListModule'
import NbnFibreExtras from '../modules/NbnFibreExtras'
import BackgroundCurves from '../components/BackgroundCurves'
import { gsap } from 'gsap'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import NbnPlanCards from "../components/NbnPlanCards";
import ScrollTo from '../components/ScrollTo'
import { appendAgentTokenInput } from '../utils/agentUtil'
import { appendGenesysIdInput } from '../utils/addGenesysId'
import modemData from "../../data/modems.json"
import { appendUtmSourceId } from '../utils/utmUtil'

gsap.registerPlugin(SplitText)
gsap.registerPlugin(MorphSVGPlugin)
window.requestAnimationFrame = window.requestAnimationFrame.bind(window) // Reqd for IE Edge in dev
gsap.registerPlugin(ScrollTrigger)

class NbnPlans extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            // CONTENT
            title: '',
            winner: {},
            modemTitle: '',
            phoneTitle: '',
            needToKnow: [],
            // PLANS
            plans: [],
            flipPlans: [],
            currentPlan: {},
            modemSelected: '',
            extenderOrdered: 0,
            voipSelected: '',
            voipSelectedPlan: VOIP_PAYG,
            homeSecureSelected: '',
            isAnimated: false,
            isPlanChanged: false,
            activeTab: ACTIVE_LEFT,
            isFibreUpgradePlan: true,
            unconnectedServiceType: 'standard'
        }

        const queryString = require('query-string');
        this.urlParams = queryString.parse(this.props.location.search)
        this.modemPrice = modemData.modem.upfrontPrice
        this.extenderPrice = modemData.extender.upfrontPrice
        this.homeSecurePrice = 6
        this.trigger1 = React.createRef()
        this.sqHeadingContainer = React.createRef()
        this.sqHeading = React.createRef()
        this.planHeadingContainer = React.createRef()
        this.planHeading = React.createRef()
    }

    componentDidMount () {
        this.getContent()
        this.getPlans(false)
        this.getCmsUnconnectedFlag()
        this.getFlipPlans()
        this.animateIn()
        globals.pushGA4Events('pageLoad', {
            eventInfo: {
                pageName: 'NBN',
                pageCategory: 'Plans',
                pageType: 'Information'
            }
        })
    }

    componentDidUpdate (prevProps, prevState) {
        if (prevProps.sqResult !== this.props.sqResult) {
            this.getPlans(true)
            this.getFlipPlans()
        }

        // Dont re-render when changing plan, it makes the shapes jump
        if (prevState.currentPlan === this.state.currentPlan) {
            if (!this.state.isAnimated) {
                this.animateIn()
            }
        }
    }

    getCmsUnconnectedFlag() {
        DataSource.getCmsUnconnectedLocationFlag(response => {
                this.setState({
                    unconnectedServiceType: response.data && response.data.unconnected_services ? response.data.unconnected_services.value : 'standard'
                })
            }, this.props.handleApiError.bind(this)
        )
    }

    getContent () {
        DataSource.getData('/api/getContent/nbn/plans-content', response => {
            this.setState({ ...response })
        })
    }

    getPlans (changedSQAddress) {
        let url = '/api/getDefaultPlansNbn'
        let baseUrl = ''
        if (this.props.getSqItem('nbnRegion') && this.props.getSqItem('nbnServiceClass')) {
            baseUrl = `/api/getPlansNbn/${this.props.getSqItem('nbnRegion')}/${this.props.getSqItem('nbnServiceClass')}/${this.props.getSqItem('maxSpeed')}`;
        }

        if (this.props.getSqItem('campaigns').length > 0 && this.props.getSqItem('campaigns').includes(UNCONNECTED_SERVICES_CAMPAIGNS) && baseUrl) {
            url = (this.state.unconnectedServiceType === UNCONNECTED_STANDARD || this.state.unconnectedServiceType === UNCONNECTED_BOOST) ? `${baseUrl}?offerType=${this.state.unconnectedServiceType}` : baseUrl
        } else {
            if (this.props.canGetService()) {
                url = baseUrl || '/api/getDefaultPlansNbn'
            }
        }

        const onSuccess = response => {
            this.setState({
                plans: response.plans,
                isLoaded: true
            }, this.setDefaults.bind(this, changedSQAddress))
        }

        DataSource.getData(url, onSuccess, this.props.handleApiError.bind(this))
    }

    getFlipPlans () {
        if (this.props.getSqItem('flipReady') && this.props.getSqItem('nbnRegion') && this.props.getSqItem('nbnServiceClass')) {
            const url = `/api/getFlipToFibrePlans/${this.props.getSqItem('nbnRegion')}/${this.props.getSqItem('nbnServiceClass')}/${this.props.getSqItem('maxSpeed')}`
            const onSuccess = response => {
                this.setState({
                    flipPlans: response.plans,
                    isLoaded: true
                }, () => {
                    if (response.plans.length > 0) {
                        this.setState({
                            currentPlan: response.plans[response.plans.length-1],
                            activeTab: ACTIVE_RIGHT
                        })
                    }
                })
            }

            DataSource.getData(url, onSuccess, this.props.handleApiError.bind(this))
        }
    }

    animateIn () {
        if (this.planHeading.current && this.sqHeading.current) {
            const headingRows = new SplitText(this.planHeading.current.querySelector('h3'))
            const sqHeadingRows = new SplitText(this.sqHeading.current)

            gsap.fromTo(sqHeadingRows.lines, {
                y: 60,
                opacity: 0
            }, {
                duration: 1,
                y: 0,
                opacity: 1,
                stagger: 0.1,
                scrollTrigger: {
                    trigger: this.sqHeadingContainer.current,
                    start: 'top-=200 center'
                }
            })

            gsap.fromTo(headingRows.lines, {
                x: -80,
                opacity: 0
            }, {
                duration: 1.6,
                x: 0,
                opacity: 1,
                stagger: 0.2,
                ease: 'back.out',
                scrollTrigger: {
                    trigger: this.planHeadingContainer.current,
                    start: 'top-=200 center'
                }
            })

            this.setState({ isAnimated: true })
        }
    }

    handleChangePlan (plan) {
        this.setState({
            currentPlan: plan,
            isPlanChanged: true
        })
    }

    handleSelectModem (value) {
        this.setState({
            modemSelected: value,
            extenderOrdered: !value ? false : this.state.extenderOrdered
        })
    }

    handleSelectExtender (amount) {
        this.setState({ extenderOrdered: amount })
    }

    // Select VoIP - Yes/No
    handleSelectVoip (value) {
        this.setState({ voipSelected: value })
    }

    // Which VoIP Plan
    handleSelectVoipPlan (value) {
        this.setState({ voipSelectedPlan: value })
    }

    handleSelectHomeSecure (value) {
        this.setState({ homeSecureSelected: value })
    }

    handleSubmitOrder () {
        const form = document.createElement('form')
        const fdclid = localStorage.getItem('fdclid')
        const data = {
            type: 'broadband',
            technology: 'nbn',
            sq_address: globals.encryptData(this.props.sqAddress),
            service_class: this.props.sqResult.nbnServiceClass,
            plan_id: this.getSelectedPlan().id,
            contract_term: 1,
            unlimited_phone: (this.state.voipSelected && this.state.voipSelectedPlan === VOIP_UNLIMITED) ? 1 : 0,
            payg_phone: (this.state.voipSelected && this.state.voipSelectedPlan === VOIP_PAYG) ? 1 : 0,
            modem: this.state.modemSelected ? 1 : 0,
            new_dev: this.props.sqResult.nbnNewDev ? 1 : 0,
            hs: (this.state.homeSecureSelected ? 'subscribe' : 'trial'),
            extender: !this.state.extenderOrdered ? 0 : this.state.extenderOrdered,
            fdclid: fdclid || '',
            referral_code: this.urlParams.referral_code || '',
            flip : this.props.sqResult.flipReady && this.state.isFibreUpgradePlan ? 1: 0,
            ...(this.props.sqResult.locId && {service_location_id: this.props.sqResult.locId }),
            active_service: this.props.sqResult.activeService ? this.props.sqResult.activeService: 0

        }

        const totalMinCost = this.calcTotalMinCost(this.calcMonthlyPrice()).toFixed(2)
        const planName = this.getSelectedPlan().planTitle
        const price = this.getSelectedPlan().special.planPrice ? this.getSelectedPlan().special.planPrice : this.getSelectedPlan().price

        globals.pushEventNbnOrderNowResi({ ...data, planName, totalMinCost })

        globals.pushEventSelectItem({...data, planName, totalMinCost, price })


        Object.keys(data).map((key) => {
            const input = document.createElement('input')
            input.name = key
            input.type = 'hidden'
            input.value = data[key]
            form.appendChild(input)
        })

        appendAgentTokenInput(form)
        appendUtmSourceId(form)
        appendGenesysIdInput(form)

        form.method = 'GET'
        form.action = 'https://staging.order.exetel.com.au/'
        if (process.env.NODE_ENV === 'production') {
            form.action = 'https://order.exetel.com.au'
        }


        this.pushOrderEvent()
        this.pushGa4OrderEvent()
        document.body.appendChild(form)
        form.submit()
    }

    pushGa4OrderEvent () {
        globals.pushGA4Events('journeyStep', {
            eventInfo: {
                journeyName: 'NBN Plans',
                stepName: 'Select plan & extras',
                stepNo: '5',
                contractType: 'none',
                planValue: this.state.currentPlan.special ? this.state.currentPlan.special.planPrice : this.state.currentPlan.price,
                modemType: this.state.modemSelected ? 'Gigabit WiFi-6 MESH 1800Mbps Modem' : '',
                extenderQuantity: this.state.extenderOrdered,
                phoneService: this.state.voipSelected ? (this.state.voipSelectedPlan === 'payg' ? 'Pay-as-you-go call rates' : '10$/mth Unlimited call pack') : '',
                secureSubscription: this.state.homeSecureSelected ? 'True' : 'False'
            }
        })
    }

    pushOrderEvent () {
        globals.pushEvent('gtm-NbnOrderStart', {
            address: this.props.sqAddress,
            serviceClass: this.props.sqResult.nbnServiceClass,
            contract: 1,
            speed: this.getSelectedPlan().id,
            data: 'unlimited',
            modemOrdered: this.state.modemSelected,
            extenderOrdered: this.state.extenderOrdered,
            voipOrdered: this.state.voipSelected,
            homeSecureOrdered: this.state.homeSecureSelected,
            price: this.calcMonthlyPrice().toFixed(2),
            totalMinCost: this.calcTotalMinCost(this.calcMonthlyPrice()).toFixed(2)
        })
    }

    getSelectedPlan () {
        return this.state.currentPlan ? this.state.currentPlan : {}
    }

    calcTotalMinCost (price) {
        let minCost = price + this.calcTotalUpfrontCost()
        if (this.state.homeSecureSelected) {
            minCost -= this.homeSecurePrice // Remove this for now since its a free trial to start
        }

        return minCost
    }

    calcTotalUpfrontCost () {
        let cost = 0

        cost += (this.state.modemSelected ? this.modemPrice : 0)
        cost += (this.state.extenderOrdered * this.extenderPrice)
        cost += this.calcOneOffNewDevFee()

        return cost
    }

    calcOneOffNewDevFee () {
        return (this.props.sqResult && this.props.sqResult.nbnNewDev) ? 300 : 0
    }

    calcMonthlyPrice (price = 0) {
        const plan = this.getSelectedPlan()
        if (!price && plan.price) {
            price = plan.price

            if (plan.special && plan.special.planPrice) {
                price = plan.special.planPrice
            }
        }

        if (this.state.voipSelected && this.state.voipSelectedPlan === VOIP_UNLIMITED) {
            price += 10
        }

        if (this.state.homeSecureSelected) {
            price += this.homeSecurePrice
        }

        return price
    }

    setDefaults (changedSQAddress) {
        const plan = this.getSelectedPlan()

        if (Object.keys(plan).length === 0 || changedSQAddress) {
            this.state.plans.length > 1 ? this.setState({currentPlan: this.state.plans[this.state.plans.length - 1]}) : this.setState({currentPlan: this.state.plans[0]})
        }
    }

    handleSqSubmit () {
        if (this.props.sqAddress) {
            const address = this.props.sqAddress
            const userAddressInfo = address.split(',').pop().trim()
            const eventsInfo = userAddressInfo.split(' ')

            globals.pushGA4Events('journeyStep', {
                eventInfo: {
                    journeyName: 'Nbn Plans',
                    stepName: 'Start with your address',
                    stepNo: '3',
                    userPostcode: eventsInfo.length >= 3 ? eventsInfo[2] : '',
                    userSuburb: eventsInfo.length >= 1 ? eventsInfo[0] : '',
                    userState: eventsInfo.length >= 2 ? eventsInfo[2] : ''
                }
            })
        }
    }

    handleSqFocus () {
        globals.pushGA4Events('journeyStep', {
            eventInfo: {
                journeyName: 'Nbn Plans',
                stepName: 'Start with your address',
                stepNo: '2'
            }
        })
    }

    handleSetFibreUpgradePlan (isFlip) {
        this.setState({
            isFibreUpgradePlan: isFlip
        })
    }

    render () {
        const PlanHeading = <h3 className='m-0'><span className='color-lime'>2. </span> Choose your <HighlightText>unlimited data</HighlightText> nbn™ plan</h3>

        return (
            <React.Fragment>
                <BannerNbn />
                <BroadbandContainer isLoaded={this.state.isLoaded || this.props.hasApiError} showOverlay={this.props.showOverlay} hasApiError={this.props.hasApiError}>
                    <div ref={this.trigger1} className='nbn-plans ml-lg-5'>
                        <div ref={this.sqHeadingContainer} className='row no-gutters'>
                            <div className='col-12 col-lg-9 text-lg-center mb-lg-5 mb-4 position-relative'>
                                <div id='sq-field-trigger' />
                                <StepTag>1</StepTag>
                                <h3 ref={this.sqHeading} className='m-0 d-none d-lg-flex text-left ml-3'>
                                    <span className='color-lime'>1. </span>  Let's check the nbn™ plans available at your home.
                                </h3>
                                <h2 className='m-0 has-step-tag d-lg-none'>
                                    Check the nbn™ plans<br /><HighlightText>available at your home.</HighlightText>
                                </h2>
                            </div>
                            <div className='col-12 col-lg-8 ml-lg-5'>
                                <SqField
                                    showOverlay={this.props.showOverlay}
                                    hideSqOverlay={this.props.hideSqOverlay.bind(this)}
                                    isOnPageSq
                                    v2
                                    handleSubmit={this.handleSqSubmit.bind(this)}
                                    handleFocus={this.handleSqFocus.bind(this)}
                                />
                                <div className='row mt-3 text-center position-relative' style={{ zIndex: 3 }}>
                                    <div className='col-12 col-lg-10 text-lg-left'>
                                        <p className='m-0 font-small d-none d-lg-block'>
                                            Different addresses have different plan options available. Enter your address details above, including your unit number if you live in an apartment, and we’ll display the nbn™ plan options available to you.
                                        </p>
                                        <p className='m-0 font-small d-lg-none px-2'>
                                            Different addresses have different plan options available. Enter your address details above, including your unit number if you live in an apartment, and we’ll display the nbn™ plan options available to you.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='plan-container col-12'>
                                <div ref={this.planHeadingContainer} className='plan-heading d-none d-lg-block mb-5'>
                                    <div className='row'>
                                        <div ref={this.planHeading} className='col-12 col-md-9 col-lg-9 text-left ml-3'>
                                            {PlanHeading}
                                        </div>
                                    </div>
                                </div>
                                <div className='d-lg-none mb-5'>
                                    <StepTag>2</StepTag>
                                    <h2 className='m-0 has-step-tag'>
                                        Swipe right to find<br />the <HighlightText>unlimited nbn™</HighlightText><br />match for you.
                                    </h2>
                                </div>
                                <div id='plans' />
                                <div className='plan-inner-wrapper'>
                                    <NbnPlanCards
                                        nbnPlans={this.state.plans}
                                        flipPlans={this.state.flipPlans}
                                        currentPlan={this.state.currentPlan}
                                        handleChangePlan={this.handleChangePlan.bind(this)}
                                        handleCalcOneOffNewDevDee={this.calcOneOffNewDevFee.bind(this)}
                                        handleCalcTotalMinCost={this.calcTotalMinCost.bind(this)}
                                        handleCalcMonthlyPrice={this.calcMonthlyPrice.bind(this)}
                                        activeTab={this.state.activeTab}
                                        handleSetFibreUpgradePlan={this.handleSetFibreUpgradePlan.bind(this)}
                                        page={'nbn'}
                                    />
                                </div>
                                <div className='text-center mt-4 mt-lg-3 pt-lg-2 px-2 terms' style={{ zIndex: 2, position: 'relative' }}>
                                {OFFER_ENDING_TEXT ? <h4 className='m-0 pb-4 bold'>
                                        {OFFER_ENDING_TEXT}
                                    </h4>: ''}
                                    <small>
                                        For <span dangerouslySetInnerHTML={{ __html: this.state.currentPlan.planHeading }} /> total minimum cost is ${this.calcTotalMinCost(this.calcMonthlyPrice())} plus any pro-rata charges for 30-day cancellation notice period.
                                    </small>
                                    <br /><br />
                                    <small>
                                        <a href={this.getSelectedPlan().cisLink} target='_blank' rel='noopener noreferrer'>Broadband critical info</a> | <a href='https://files.exetel.com.au/terms/NBN_Key_Facts_Sheet.pdf' target='_blank' rel='noreferrer'>Fact sheet</a>
                                    </small>
                                </div>
                            </div>
                        </div>
                        <NbnFibreExtras
                            modemSelected={this.state.modemSelected}
                            extenderOrdered={this.state.extenderOrdered}
                            voipSelected={this.state.voipSelected}
                            voipSelectedPlan={this.state.voipSelectedPlan}
                            homeSecureSelected={this.state.homeSecureSelected}
                            handleSelectModem={this.handleSelectModem.bind(this)}
                            handleSelectExtender={this.handleSelectExtender.bind(this)}
                            handleSelectVoip={this.handleSelectVoip.bind(this)}
                            handleSelectVoipPlan={this.handleSelectVoipPlan.bind(this)}
                            handleSelectHomeSecure={this.handleSelectHomeSecure.bind(this)}
                            type={SERVICE_NBN}
                            shows
                        />
                    </div>
                    <BroadbandOrderSummary
                        handleSubmitOrder={this.handleSubmitOrder.bind(this)}
                        requestedServiceType={SERVICE_NBN}
                        totalMinCost={this.calcTotalMinCost(this.calcMonthlyPrice())}
                        totalUpfrontCost={this.calcTotalUpfrontCost()}
                        calcMonthlyPrice={this.calcMonthlyPrice.bind(this)}
                        plan={this.getSelectedPlan()}
                        modemPrice={this.modemPrice}
                        extenderPrice={this.extenderPrice}
                        modemSelected={this.state.modemSelected}
                        extenderOrdered={this.state.extenderOrdered}
                        voipSelected={this.state.voipSelected}
                        voipSelectedPlan={this.state.voipSelectedPlan}
                        homeSecureSelected={this.state.homeSecureSelected}
                        newDev={this.calcOneOffNewDevFee()}
                    />
                </BroadbandContainer>
                <div className='pt-5 py-lg-5 broadband-plans-features'>
                    <NbnFeatures className='pt-0 mb-0' hasBasicHeading />
                </div>
                <BackgroundCurves color='lightgrey' innerClassName='inner-container pb-5' hideBottomCurve>
                <div id='thingsToKnow' />
                    <ExpandableListModule title='Things you need to know' data={this.state.needToKnow} hasPadding={false} />
                </BackgroundCurves>
            </React.Fragment>
        )
    }
}

NbnPlans.propTypes = {
    getSqItem: PropTypes.func,
    canGetService: PropTypes.func,
    hideSqOverlay: PropTypes.func,
    handleApiError: PropTypes.func,
    showOverlay: PropTypes.bool,
    hasApiError: PropTypes.bool
}

export default PlanHOC(NbnPlans, SERVICE_NBN)



// WEBPACK FOOTER //
// ./resources/js/nbn/NbnPlans.js